import React from 'react'

import classes from './styles'

class Preloader extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
    }

    this.firstTimeoutId = null
    this.secondTimeoutId = null
  }

  componentDidMount = () => {
    if (! this.state.show) {
      this.firstTimeoutId = setTimeout(() => {
        this.setState({
          show: true
        })

        this.secondTimeoutId = setTimeout(() => {
          this.setState({
            show: false
          })
        }, 1200)
      }, 100)
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.firstTimeoutId)
    clearTimeout(this.secondTimeoutId)
  }

  render() {
    const additionalClasses = this.state.show ? classes.showPreloader : ''

    return (
      <div className={[classes.preloaderBlock, additionalClasses].join(' ')}>
        <img className={classes.preloader} src="https://10years.lifehacker.ru/publisher/images/dice.gif" alt=""/>
      </div>
    )
  }
}

Preloader.propTypes = {}

export default Preloader


// WEBPACK FOOTER //
// ./src/components/Question/components/Result/Preloader.jsx